import vSelect from 'vue-select'

// Vue Select 3 does not expose props for these built-in accessibility labels.
// Keep the original control and localize only its labels after rendering.
export default {
  extends: vSelect,
  props: {
    accessibleLabel: {
      type: String,
      default: '',
    },
  },
  computed: {
    resolvedAccessibleLabel() {
      return this.accessibleLabel || this.$t('common.searchAndSelectOption')
    },
  },
  watch: {
    '$i18n.locale': 'localizeLabels',
    resolvedAccessibleLabel: 'localizeLabels',
  },
  mounted() {
    this.localizeLabels()
  },
  updated() {
    this.localizeLabels()
  },
  methods: {
    localizeLabels() {
      const { toggle } = this.$refs
      if (toggle) toggle.setAttribute('aria-label', this.resolvedAccessibleLabel)
      const clearButton = this.$el.querySelector('.vs__clear')
      if (clearButton) {
        clearButton.setAttribute('title', this.$t('common.clearSelection'))
        clearButton.setAttribute('aria-label', this.$t('common.clearSelection'))
      }
      this.$el.querySelectorAll('.vs__deselect').forEach((button, index) => {
        const option = this.getOptionLabel(this.selectedValue[index])
        const label = this.$t('apps.removeItem', { value1: option })
        button.setAttribute('title', label)
        button.setAttribute('aria-label', label)
      })
    },
  },
}
